import { BASE_URL } from "../app/config";
import { Api, OpenApi } from "./api";

export const getHeaderInfo = async ({ referenceNumber, token }) => {
  const res = await Api.get(
    `/iam-entry/invoices/${referenceNumber}/header-info?token=${encodeURIComponent(token)}`,
  );
  return res.data;
};

export const getInvoiceHeaderInfo = async ({
  taxCode,
  thirdPartyCode,
  token,
}) => {
  const res = await OpenApi.get(
    `/api/lookup/invoice-header?token=${encodeURIComponent(token)}&taxCode=${taxCode}&thirdPartyCode=${thirdPartyCode}`,
  );
  return res.data;
};

export const updateBuyerInfo = async ({ invoiceId, buyerInfo, token }) => {
  const res = await OpenApi.put(
    `/api/lookup/${invoiceId}/buyer-info?token=${encodeURIComponent(token)}`,
    buyerInfo,
  );
  return res.data;
};

export const getTaxCodeInfo = async (taxCode, token) => {
  const res = await OpenApi.get(
    `/api/lookup/tax-info?token=${encodeURIComponent(token)}&taxCode=${encodeURIComponent(taxCode)}`,
  );
  return res.data;
};

export const downloadInvoicePdf = async (referenceNumber) => {
  const res = await Api.get(`iam-entry/invoices/${referenceNumber}/pdf`, {
    responseType: "blob",
  });

  return res.data;
};

export const downloadInvoiceXML = async (referenceNumber) => {
  const res = await Api.get(`iam-entry/invoices/${referenceNumber}/xml`, {
    responseType: "blob",
  });

  return res.data;
};

export const convertInvoice = async (referenceNumber, name) => {
  const res = await Api.get(
    `iam-entry/invoices/${referenceNumber}/converted?convertedName=${name}`,
    {
      responseType: "blob",
    },
  );

  return res.data;
};
